import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RequestService } from '../../../core/services/request.service';
import { ConfigService } from '../../../core/services/config.service';
import { ApprovalPolicy } from './models';

@Injectable()
export class ApprovalsService {

    private allConfigurations: any = null;

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    getApprovedRuleListUrl(): string {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.fetchApprovedRules.api;
    }

    getTransactionApprovalRequestsByStatusUrl(): string {
        return this.configService.get('server').url + this.configService.get('endpoints').odyssey.approvals.fetchTransactionApprovalRequestsByStatus.api;
    }

    getConsumptionApprovalRequestsByStatusUrl(): string {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.fetchConsumptionApprovalRequestsByStatusAndType.api;
    }

    approveConsumptionRequest(payload: { id: string, externalReference?: string }): Observable<any> {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.approveConsumptionRequest.api;
        return this.requestService.post(url, payload);
    }

    rejectConsumptionRequest(payload: { id: string, rejectionReason: string }): Observable<any> {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.rejectConsumptionRequest.api;
        return this.requestService.post(url, payload);
    }

    getApprovalPolicies(ruleType: string): Observable<ApprovalPolicy[]> {
        return this.requestService.get(this.getApprovedRuleListUrl(), { 'filter': ruleType }).map(_ => _.data);
    }

    getPendingApprovalsListUrl() {
        return this.configService.get('server').url + this.configService.get('endpoints').odyssey.approvals.fetchPendingApprovals.api;
    }

    fetchUsersByName() {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.fetchUsersForApprovalGroup.api + '?filter' + '';
        return this.requestService.get(url).map(_ => _.data);
    }

    saveApprovalGroup(payload) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.saveUsersForApprovalGroup.api;
        return this.requestService.post(url, payload).map(_ => _.data);
    }

    editApprovalGroup(payload) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.editUsersForApprovalGroup.api;
        return this.requestService.post(url, payload).map(_ => _.data);
    }

    saveApprovalRule(payload) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.addApprovedRules.api;
        return this.requestService.post(url, payload, true).map(_ => _.data);
    }

    editApprovalRule(payload) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.editApprovedRules.api;
        return this.requestService.post(url, payload).map(_ => _.data);
    }

    fetchApprovalGroups() {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.fetchApprovalGroups.api;
        return this.requestService.get(url).map(_ => _.data);
    }

    fetchRuleOperatorTypes() {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.fetchRuleOperatorTypes.api;
        return this.requestService.get(url).map(_ => _.data);
    }

    fetchRuleType() {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.fetchRuleType.api;
        return this.requestService.get(url).map(_ => _.data);
    }

    fetchCurrencyForBuyer(domain) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.fetchCurrencyForBuyer.api + '/' + domain;
        return this.requestService.get(url).map(_ => _.data);
    }

    deleteApprovalRule(payload) {
        let pay = { id: payload.id };
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.approvals.deleteApprovedRules.api;
        return this.requestService.post(url, pay).map(_ => _.data);
    }

    fetchListOfPendingApprovalsURI() {
        return this.configService.get('server').url + this.configService.get('endpoints').odyssey.approvals.fetchCurrencyForBuyer.api;
    }

    approvePayment(id) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.approvals.approvePayment.api + '/' + id;
        return this.requestService.get(url).map(_ => _.data);
    }

    rejectPayment(id, payload) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.approvals.rejectPayment.api + '/' + id;
        return this.requestService.post(url, payload).map(_ => _.data);
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/approvals.service.ts